export default __webpack_public_path__ + "static/media/quality-of-life.8157a21c.jpg";